// extracted by mini-css-extract-plugin
module.exports = {"page":"kXJZbbGNEoGqV8cm5+JRvA==","modal":"YiHbHLb2iOYDecgSVVafow=="};